export const mapReducer = function (state = 0, action) {
  switch (action.type) {
    case "ADD_HIGHLIGHT":
      console.log('dd', action);
      return state + 1;
    case "DECREMENT":
      return state - 1;
    default:
      return state;
  }
};
